import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { of } from 'rxjs';

import { DeviceService } from '@app/services/device.service';
import { ModalService } from '@app/services/modal.service';
import { DeviceBaseComponent } from '@app/shared/device-base.component';
import { Device } from '@app/store/device.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-save-to-device-button',
  templateUrl: './save-to-device-button.component.html',
  imports: [NgbTooltip, AsyncPipe],
})
export class SaveToDeviceButtonComponent extends DeviceBaseComponent {
  private deviceService = inject(DeviceService);
  private modalService = inject(ModalService);

  disabled$ = of(false);

  onDeviceChange(device: Device) {
    this.disabled$ = this.deviceService.selectDeviceSaveConfigurationButtonDisabled(device);
  }

  onSaveToDevice() {
    this.modalService.openDeviceConfirmSaveWithFirmwareLoggingChange(this.device);
  }

  onViewChangedValues() {
    this.modalService.openViewCurrentChangesModal(this.device);
  }
}
